import { RecommendationSlider } from '../RecommendationSlider/RecommendationSlider.js';
import { type UserReviews_userProfile$key } from '@/__generated__/relay/UserReviews_userProfile.graphql.js';
import { Layout } from '@/components/Layout/Layout.js';
import { MobileRecommendations } from '@/components/Recommendation/MobileRecommendations/MobileRecommendations.js';
import { Section } from '@/components/Section/Section.js';
import { UserReviewsFragment } from '@/documents/fragments/UserReviews.js';
import { useIPFragment } from '@/hooks/useIPFragment.js';
import { useMatchMedia } from '@/hooks/useMatchMedia.js';
import { useUserProfile } from '@/hooks/useUserProfile.js';
import { minWidthMediaQueries } from '@/stitches/media.js';
import { buildUserReviews } from '@/utilities/buildUserReviews.js';

export type RecommendationsProps = {
  readonly queryRef: UserReviews_userProfile$key;
};

export const Recommendations = ({ queryRef }: RecommendationsProps) => {
  const isMediumViewport = useMatchMedia(minWidthMediaQueries.bp2);
  const result = useIPFragment<UserReviews_userProfile$key>(
    UserReviewsFragment,
    queryRef,
  );
  const userProfile = useUserProfile();

  if (!result) return null;

  const recommendations = buildUserReviews(result.userReviews, userProfile?.id);

  if (!recommendations.length) return null;

  return isMediumViewport ? (
    <Section
      css={{ paddingTop: '$120' }}
      id="recommendations"
    >
      <Layout.Grid>
        <Layout.GridColumn
          center
          initial={isMediumViewport ? 10 : 12}
        >
          <RecommendationSlider items={recommendations} />
        </Layout.GridColumn>
      </Layout.Grid>
    </Section>
  ) : (
    <MobileRecommendations
      recommendations={recommendations}
      uppercaseTrigger={false}
    />
  );
};
